import { css } from 'styled-components';

export function createBreakpoint(breakpoints) {
  const keys = Object.keys(breakpoints || {});

  return function breakpointFactory(size, sizeEnd) {
    return (strings, ...interpolations) => {
      const min = breakpoints[size] !== undefined ? breakpoints[size] : 0;
      const max = sizeEnd && breakpoints[sizeEnd] !== undefined ? breakpoints[sizeEnd] : null;
      const body = strings.reduce((acc, str, i) => acc + str + (interpolations[i] !== undefined ? interpolations[i] : ''), '');
      const media = max
        ? `@media (min-width: ${min}px) and (max-width: ${max}px)`
        : `@media (min-width: ${min}px)`;
      return css`
        ${media} {
          ${body}
        }
      `;
    };
  };
}

export function createMap(breakpoints) {
  return Object.assign({}, breakpoints);
}

export default { createBreakpoint, createMap };
